<template>
  <auth-template v-if="!loading">
    <div v-if="expired">
      <h2>{{ env }}Activate Account</h2>

      <b-alert variant="warning" show>
        <strong>Activation Link Expired</strong>
        <div>
          Your activation link has expired but we have sent you a new link.
          <br /><br />
          Please check your e-mail for the new link to continue setting up your
          account.
        </div>
      </b-alert>

      <hr />

      <div>
        <span @click="loadLogin" class="password-link">Return to Login</span>
      </div>
    </div>

    <form v-else @submit.prevent="activate">
      <h2>{{ env }}Activate Account</h2>

      <div class="element">
        <input
          required
          v-model="form.password"
          type="password"
          placeholder="New Password"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          title="Must contain at least one  number and one uppercase and lowercase letter, and at least 8 or more characters"
        />
      </div>

      <div class="element">
        <input
          required
          v-model="form.passwordConfirm"
          type="password"
          placeholder="Confirm New Password"
        />
      </div>

      <b-button type="submit" variant="success">Set Password</b-button>

      <hr />

      <div>
        <router-link to="/login" class="password-link"
          >Back to login</router-link
        >
      </div>
    </form>
  </auth-template>
</template>

<script>
import { recaptcha } from "@/components/mixins/recaptcha";
import AuthTemplate from "@/views/Auth/AuthTemplate.vue";

export default {
  name: "Register",
  props: {
    activateRef: {
      type: String,
      required: true
    }
  },
  components: { AuthTemplate },
  mixins: [recaptcha],
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  data() {
    return {
      loading: true,
      expired: false,
      form: {
        password: "",
        passwordConfirm: ""
      }
    };
  },
  created() {
    this.checkAccount();
  },
  methods: {
    loadLogin() {
      this.$router.push("/login");
    },
    async checkAccount() {
      const title = "Verifying your account";
      const subtitle = "Please wait a moment";
      await this.$store.dispatch("loaderInitiate", { title, subtitle });

      const token = await this.recaptchaToken();

      const key = this.activateRef;
      this.$store
        .dispatch("activateVerify", { key, token })
        .then(response => {
          if (response.status === "expired") {
            this.expired = true;
          }
          this.loading = false;
        })
        .catch(err => {
          const title = "Activation Failed";
          const subtitle = err;
          this.$store.dispatch("pushError", { title, subtitle });
          this.loadLogin();
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    },
    async activate() {
      if (this.form.password !== this.form.passwordConfirm) {
        const title = "Password's do not match";
        const subtitle = "Please confirm the same password";
        const samePage = true;
        await this.$store.dispatch("pushError", { title, subtitle, samePage });
        return;
      }

      const title = "Activating your account";
      const subtitle = "Please wait a moment";
      await this.$store.dispatch("loaderInitiate", { title, subtitle });

      const token = await this.recaptchaToken();

      const key = this.activateRef;
      const password = this.form.password;
      const passwordConfirm = this.form.passwordConfirm;
      this.$store
        .dispatch("activate", { key, password, passwordConfirm, token })
        .then(() => {
          const title = "Account Activated";
          const subtitle = "You can now login to your account";
          this.$store.dispatch("pushSuccess", { title, subtitle });
          this.loadLogin();
        })
        .catch(err => {
          const title = "Activation Failed";
          const subtitle = err;
          this.$store.dispatch("pushError", { title, subtitle });
          this.loadLogin();
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.password-link {
  cursor: pointer;
  font-size: 0.8rem;
}

h2 {
  text-align: center !important;
  font-size: 1.4rem !important;
}

h3 {
  font-size: 1.1rem;
}
</style>
